import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { AppService } from "src/app/core/service/app.service";
import { DmsDocument } from "../../models/dms-document";
import { UserAccount } from "../../models/user-account";

@Component({
  selector: "app-profile-pic",
  templateUrl: "./profile-pic.component.html",
  styleUrls: ["./profile-pic.component.sass"],
})
export class ProfilePicComponent implements OnInit {
  @Input() type: string;
  @Input() userId: string;
  @Input() documentId: number;
  @Input() Imgsrc: string;
  @Input() userType: string;

  dmsDocument: DmsDocument;
  userAccount: UserAccount;
  imgSrc: SafeUrl;
  height = 32;
  width = 55;
  constructor(private appService: AppService, private sanitizer: DomSanitizer) {
    this.dmsDocument = new DmsDocument();
  }

  ngOnInit(): void {}
  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      const Id = changes.documentId?.currentValue;
      this.userType = changes?.userType?.currentValue;
      // this.Imgsrc = changes.Imgsrc?.currentValue;
      if (Id !== null) {
        this.getProfilePicture(Id);
      }
    }
  }

  getProfilePicture(documentId) {
    const doc = { DocumentId: documentId };
    this.appService.getProfilePicture(doc).subscribe((res: any) => {
      if (!res.HasErrors) {
        this.dmsDocument = Object.assign({}, res);
        if (this.dmsDocument.Base64Url) {
          this.imgSrc = this.getSanitizeUrl(this.dmsDocument.Base64Url);
          // this.imgSrc !== 0 ? this.imgSrc : "./assets/images/default-user.png";
        }
      } else {
        if (this.userType == "patient") {
          this.imgSrc = "./assets/images/user/patient-1.png";
        } else if (this.userType == "pharmacy") {
          this.imgSrc = "./assets/images/pages/logo-1.jpg";
        } else if (this.userType == "pharmacist") {
          this.imgSrc = "./assets/images/user/user-1.png";
        } else if (this.userType == "doctor") {
          "./assets/images/pages/dr.png";
        }
      }
    });
  }

  public getSanitizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
